export default __webpack_public_path__ + "static/logo-manifest-3b2baf2efe56f17791a0222d252bac50.png";